import React, { useMemo, useState } from "react";
import { ReactComponent as InformationIcon } from "./../../images/svg/information.svg";
import { ReactComponent as LoadingIcon } from "./../../images/svg/loader.svg";
import { ReactComponent as ExportIcon } from "./../../images/svg/export.svg";
import { ReactComponent as ArrowDownIcon } from "./../../images/svg/arrowDown.svg";
import { gettext } from "../../adapter";
import TemperatureChart from "./TemperatureChart";
import RhRadiationChart from "./RhRadiationChart";
import WindChart from "./WindChart";
import { useSelector } from "react-redux";
import { export2Csv, parseRegionData } from "../../utils/weatherForecastUtils";
import PrecipitationChartChance from "./PrecipitationChartChance";

const WeatherForecastCharts = () => {
  const [exportOpen, setExportOpen] = useState(false);

  const regionState = useSelector((state) => {
    return state.weatherRegion;
  });

  const { region, isFetching } = useMemo(() => {
    if (!regionState.region) {
      return { ...regionState };
    } else {
      return {
        ...parseRegionData(regionState.regionData),
      };
    }
  }, [regionState]);

  let domain = [];
  if (region) {
    domain.push(region.firstDataPointDate);
    domain.push(region.lastDataPointDate);
  }

  if (!region || !region.firstDataPointDate) return <div />;

  var preloaderClass = "object-preloader is-loaded";
  if (isFetching) {
    preloaderClass = "object-preloader is-loading";
  }

  var exportClass = "panel-options__item dropdown__wrapper";
  if (exportOpen) {
    exportClass = "panel-options__item dropdown__wrapper is-open";
  }

  return (
    <div>
      <div>
        <div className="l-full">
          <div className="panel has-object-preloader">
            <div className={preloaderClass}>
              <div className="object-preloader--content">
                <LoadingIcon className="loader" />
              </div>
            </div>

            <div className="panel--header">
              <h2>
                {gettext("Weather forecast")} - {region.name}
              </h2>

              <ul className="panel-options">
                <li
                  className={exportClass}
                  onClick={() => {
                    setExportOpen(!exportOpen);
                  }}
                >
                  {/* eslint-disable-next-line */}
                  <a className="dropdown--toggle">
                    <ExportIcon className="icon" /> {gettext("Export")}
                  </a>

                  <div className="dropdown">
                    <ul className="dropdown__list">
                      <li>
                        {/* eslint-disable-next-line */}
                        <a onClick={() => export2Csv(region)}>{gettext("To CSV")}</a>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>

              <div className="panel--settings">
                <div className="dropdown">
                  {/* eslint-disable-next-line */}
                  <a className="dropdown--toggle">
                    <ArrowDownIcon className="icon dropdown--arrow" />
                    {gettext("Export")}
                  </a>
                  <div className="dropdown--popout ">
                    <ul className="dropdown--list">
                      <li>
                        {/* eslint-disable-next-line */}
                        <a onClick={() => export2Csv(region)}>{gettext("To CSV")}</a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="panel--settings__item">
                  <div
                    id="information"
                    className="dropdown"
                    onClick={() => {
                      var info = document.querySelector("#information"); // Using a class instead, see note below.
                      info.classList.toggle("is-open");
                    }}
                  >
                    {/* eslint-disable-next-line */}
                    <a className="panel--settings__icon">
                      <InformationIcon className="icon" />
                    </a>
                    <div className="dropdown--popout is-visible dropdown--popout__moretop dropdown--popout__wide">
                      <div className="dropdown--popout__content">
                        <p>Ik ben de HTML content</p>
                        <h3>test</h3>
                        <p>Ik ben de HTML content</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <TemperatureChart station={region} domain={domain} />
            <RhRadiationChart station={region} domain={domain} />
            <PrecipitationChartChance station={region} domain={domain} />
            <WindChart station={region} domain={domain} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeatherForecastCharts;
